import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-520ea724"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fields-overlay" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Passe die Felder in diesem Abschnitt an. Die Namen der Felder sollten nicht bearbeitet werden. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Achtung!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Felder in diesem Abschnitt", -1))
const _hoisted_6 = { class: "field-wrapper" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { class: "add-button-wrapper" }
const _hoisted_9 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_alert = _resolveComponent("md-alert")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_select = _resolveComponent("md-select")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_card = _resolveComponent("md-card")!
  const _component_md_overlay = _resolveComponent("md-overlay")!

  return (_openBlock(), _createBlock(_component_md_overlay, {
    title: "Abschnitt bearbeiten",
    ref: "overlay"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_md_alert, {
          variant: "warning",
          icon: "warning",
          style: {"margin-bottom":"12px"}
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(),
            _hoisted_4,
            _createTextVNode(" Durch das Ändern des Namens dieses Abschnitts oder von Feldern werden Daten eventuell nicht mehr angezeigt. Bitte ändere den Namen von Feldern nur, wenn dies unbedingt notwendig ist. ")
          ]),
          _: 1
        }),
        _createVNode(_component_md_input_field, {
          required: "",
          variant: "filled",
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          label: "Name des Abschnitts",
          ref: "nameInput"
        }, null, 8, ["modelValue"]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, k) => {
            return (_openBlock(), _createBlock(_component_md_card, {
              key: k,
              variant: "outlined",
              class: "field"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_md_input_field, {
                  modelValue: field.label,
                  "onUpdate:modelValue": ($event: any) => ((field.label) = $event),
                  label: "Label",
                  variant: "outlined",
                  size: "small",
                  onChange: ($event: any) => (_ctx.onLabelChange(field))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                _createVNode(_component_md_select, {
                  label: "Typ",
                  variant: "outlined",
                  size: "small",
                  items: _ctx.types,
                  error: false,
                  modelValue: field.type,
                  "onUpdate:modelValue": ($event: any) => ((field.type) = $event)
                }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]),
                (field.type === 'select')
                  ? (_openBlock(), _createBlock(_component_md_input_field, {
                      key: 0,
                      style: {"margin-top":"12px"},
                      modelValue: field.rawValues,
                      "onUpdate:modelValue": ($event: any) => ((field.rawValues) = $event),
                      label: "Optionen",
                      placeholder: "Option 1,Option 2, Option 3",
                      variant: "outlined",
                      size: "small",
                      onChange: ($event: any) => (_ctx.onLabelChange(field))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                  : _createCommentVNode("", true),
                _createElementVNode("h5", null, _toDisplayString(_ctx.dbSectionName) + "." + _toDisplayString(field.name), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_md_button, {
                      variant: "icon",
                      mode: "icon_small",
                      icon: "keyboard_arrow_up",
                      onClick: ($event: any) => (_ctx.moveField(k, k - 1))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_md_button, {
                      variant: "icon",
                      mode: "icon_small",
                      icon: "keyboard_arrow_down",
                      onClick: ($event: any) => (_ctx.moveField(k, k + 1))
                    }, null, 8, ["onClick"])
                  ]),
                  _createVNode(_component_md_button, {
                    variant: "icon",
                    grey: "",
                    mode: "icon_small",
                    icon: "delete_forever",
                    onClick: ($event: any) => (_ctx.fields.splice(k, 1))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_md_button, {
            variant: "text",
            icon: "add",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addField()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Feld hinzufügen")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_md_button, {
            variant: "text",
            grey: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Abbrechen")
            ]),
            _: 1
          }),
          _createVNode(_component_md_button, {
            variant: "filled",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateSection()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Änderungen speichern")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 512))
}